import { AfterViewInit, Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from "@angular/material";

@Component({
  selector: "groupOrderQrCodeDialog",
  templateUrl: "./groupOrderQrCodeDialog.component.html",
  styleUrls: ["./groupOrderQrCodeDialog.component.scss"]
})

export class GroupOrderQrCodeDialogComponent implements OnInit, AfterViewInit, OnDestroy {

  public inviteQrCodesvg: string;

  constructor(public bottomSheetRef: MatBottomSheetRef<GroupOrderQrCodeDialogComponent>
    , @Inject(MAT_BOTTOM_SHEET_DATA) public dialogData: string) {
    const me = this;
  }

  ngOnInit() {
    const me = this;
    me.inviteQrCodesvg = me.dialogData.trim();
  }

  async ngAfterViewInit(): Promise<void> { }

  async ngOnDestroy(): Promise<void> { }

  public closeBottomSheet() {
    const me = this;
    me.bottomSheetRef.dismiss(true);
  }
}
